import { Container } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import { ReportProvider } from "../../contexts/ReportContext";
import { ResourceProvider } from "../../contexts/ResourceContext";
import withAuthentication from "../../hocs/withAuthentication";
import Details from "./Details";
import Form from "./Form";
import History from "./History";
import Report from "./Report";

const Page: React.FC = () => {
  return (
    <ResourceProvider>
      <Routes>
        <Route element={<History />} path="/" />
        <Route element={<Form />} path="/create" />
        <Route
          element={
            <ReportProvider>
              <Report type="analysis" />
            </ReportProvider>
          }
          path="/:cycleId/analysis"
        />
        <Route
          element={
            <ReportProvider>
              <Report type="report" />
            </ReportProvider>
          }
          path="/:cycleId/report"
        />
        <Route
          element={
            <ReportProvider>
              <Report type="history" />
            </ReportProvider>
          }
          path="/:cycleId"
        />
        <Route element={<Details />} path="/:cycleId/:oocyteId" />
      </Routes>
    </ResourceProvider>
  );
};

export default withAuthentication(Page);
